import { store } from '@/store';

export default {

    saveBlocks() {
        let blocks = store.getters['builder/blocks'];
        let blockElements = document.querySelectorAll('.block');
        for (let i = 0; i < blockElements.length; i++) {
            if (blocks[i]['text'] !== undefined) {
                blocks[i]['text'] = blockElements[i].querySelector('.block-item').innerHTML;
            }
        }
        store.commit('builder/setBlocks', blocks);
        return store.getters['builder/action'];
    },

    disableBlockElements(exception = null) {
        let blockElements = document.querySelectorAll('.block');
        for (let i = 0; i < blockElements.length; i++) {
            blockElements[i].classList.add('disabled');
        }
        if (exception) {
            exception.classList.remove('disabled');
        }
    },

    enableBlockElements() {
        let blockElements = document.querySelectorAll('.block');
        for (let i = 0; i < blockElements.length; i++) {
            blockElements[i].classList.remove('disabled');
        }
    },

    activateBlockElement(blockElement) {
        this.deactivateBlockElements();
        blockElement.parentElement.classList.add('active');
    },

    deactivateBlockElements() {
        let blockElements = document.querySelectorAll('.block');
        for (let i = 0; i < blockElements.length; i++) {
            blockElements[i].parentElement.classList.remove('active');
        }
    },

    getBlockElementIndex(blockElement) {
        let blockElements = document.getElementById('blocks');
        let nodes = Array.prototype.slice.call(blockElements.querySelectorAll('.block'));
        return nodes.indexOf(blockElement);
    },

    getBlockElementAtIndex(index) {
        let blockElements = document.getElementById('blocks');
        let nodes = Array.prototype.slice.call(blockElements.querySelectorAll('.block'));
        return nodes[index];
    },

    selectRange() {
        let sel = window.getSelection();
        let blockElement = sel.focusNode?.parentElement?.closest('.block');
        let types = ['headline', 'paragraph'];
        if (blockElement && types.includes(blockElement.getAttribute('data-type'))) {
            return sel.getRangeAt(0);
        }
        return null;
    },

    updateBlockElementAtIndex(index) {
        let block = store.getters['builder/blocks'][index];
        let blockElement = this.getBlockElementAtIndex(index);
        let blockElementContent = blockElement.getElementsByClassName('block-content')[0];
        let blockElementItems = blockElement.querySelectorAll('.block-item');

        // Block container styles.
        if (block?.container) {
            let el = blockElementContent;
            el.style['background-color'] = block.container.background_color;
            el.style['border-color'] = block.container.border_color;
            el.style['border-top-width'] = block.container.border_top_width;
            el.style['border-bottom-width'] = block.container.border_bottom_width;
            el.style['border-left-width'] = block.container.border_left_width;
            el.style['border-right-width'] = block.container.border_right_width;
            el.style['border-top-left-radius'] = block.container.border_top_left_radius;
            el.style['border-top-right-radius'] = block.container.border_top_right_radius;
            el.style['border-bottom-left-radius'] = block.container.border_bottom_left_radius;
            el.style['border-bottom-right-radius'] = block.container.border_bottom_right_radius;
            el.style['padding-top'] = block.container.padding_top;
            el.style['padding-right'] = block.container.padding_right;
            el.style['padding-bottom'] = block.container.padding_bottom;
            el.style['padding-left'] = block.container.padding_left;
            el.style['text-align'] = block.container.text_align;
        }

        // Block item styles.
        if (['headline', 'paragraph', 'badge'].includes(block.type)) {
            let el = blockElementItems[0];
            el.style['background-color'] = block.background_color;
            el.style['color'] = block.color;
            el.style['link_color'] = block.link_color;
            el.style['font-family'] = block.font_family;
            el.style['font-size'] = block.font_size;
            el.style['letter-spacing'] = block.letter_spacing;
            el.style['line-height'] = block.line_height;
            el.style['text-align'] = block.text_align;
            if (el.querySelector('a')) el.querySelector('a').style['color'] = block.link_color;
        } else if (block.type === 'code') {
            let el = blockElementItems[0];
            el.innerHTML = block.code;
        } else if (block.type === 'image') {
            let el = blockElementItems[0];
            el.setAttribute('href', block.link);
            el.querySelector('img').setAttribute('src', block.src);
            el.querySelector('img').setAttribute('alt', block.alt);
            el.querySelector('img').setAttribute('width', '');
            el.querySelector('img').style['height'] = block.height;
            el.querySelector('img').style['max-width'] = block.max_width;
            el.querySelector('img').style['width'] = block.width;
        } else if (block.type === 'logo') {
            let el = blockElementItems[0];
            el.setAttribute('href', block.link);
            el.querySelector('img').setAttribute('src', block.src);
            el.querySelector('img').setAttribute('alt', block.alt);
            el.querySelector('img').setAttribute('height', '');
            el.querySelector('img').style['max-height'] = block.max_height;
            el.querySelector('img').style['width'] = block.width;
        } else if (block.type === 'button') {
            let el = blockElementItems[0];
            el.innerHTML = block.text;
            el.setAttribute('href', block.link);
            el.style['background-color'] = block.background_color;
            el.style['border-radius'] = block.border_radius;
            el.style['color'] = block.color;
            el.style['font-family'] = block.font_family;
            el.style['font-size'] = block.font_size;
            el.style['font-style'] = block.font_style;
            el.style['font-weight'] = block.font_weight;
            el.style['letter-spacing'] = block.letter_spacing;
            el.style['line-height'] = block.line_height;
            el.style['padding-bottom'] = block.padding_bottom;
            el.style['padding-left'] = block.padding_left;
            el.style['padding-right'] = block.padding_right;
            el.style['padding-top'] = block.padding_top;
            el.style['text-decoration'] = block.text_decoration;
            el.style['text-transform'] = block.text_transform;
        } else if (block.type === 'divider') {
            let el = blockElementItems[0];
            el.style['border-top-color'] = block.border_top_color;
            el.style['border-top-style'] = block.border_top_style;
            el.style['border-top-width'] = block.border_top_width;
            el.style['width'] = block.width;
        } else if (block.type === 'spacer') {
            let el = blockElementItems[0];
            el.style['height'] = block.height;
        } else if (block.type === 'social') {
            block.items.forEach((item, index) => {
                let el = blockElementItems[index];
                el.setAttribute('href', item.link);
                el.querySelector('img').setAttribute('src', item.src);
                el.style['background-color'] = item.background_color;
                el.style['border-radius'] = item.border_radius;
                el.style['display'] = item.display;
                el.style['height'] = item.height;
                el.style['width'] = item.width;
            });
        } else if (block.type === 'unsub') {
            let el = blockElementItems[0];
            el.innerHTML = block.text;
            el.style['background-color'] = block.background_color;
            el.style['color'] = block.color;
            el.style['link_color'] = block.link_color;
            el.style['font-family'] = block.font_family;
            el.style['font-size'] = block.font_size;
            el.style['letter-spacing'] = block.letter_spacing;
            el.style['line-height'] = block.line_height;
            el.style['text-align'] = block.text_align;
        }
    },
}